<template>
	<nav class="navbar navbar-main navbar-dark navbar-expand-lg sticky-top">
		<transition name="list" mode="out-in">
			<main-mega-menu
				v-if="isShowMegaMenu"
				:participant="participant"
				@close="closeMegaMenu"
				@showModalLogoutConfirmation="showModalLogoutConfirmation"
				@showChangeRole="showChangeRole"
				@showUserManual="showUserManual"
				@showQrEvent="showQrEvent"
			/>
		</transition>
		<div class="container-fluid p-0">
			<span class="navbar-brand d-flex align-items-center">
				<img
					:src="customNavLogo"
					class="d-inline-block align-top main-nav-logo"
					alt="Custom Logo"
					@click="gotToMainMenu()"
					v-if="customNavLogo"
				>
				<img
					src="../assets/logo-small.png"
					class="d-inline-block align-top main-nav-logo"
					alt="MyMeet"
					@click="gotToMainMenu()"
					v-else
				>

				<!-- <span class="nav-agenda-list-mobile" v-if="isInEventPage" @click="returnToAgendaList()">
					{{ $t('agenda') }}
				</span> -->
			</span>
			<button
				class="navbar-toggler mega-mobile-menu-toggle"
				type="button"
				data-toggle="collapse"
				aria-expanded="false"
				aria-label="Toggle navigation"
				@click="toggleMegaMenu()">
				<i class="material-icons">{{ this.isShowMegaMenu ? 'close' : 'menu' }}</i>
			</button>
			<div class="main-nav-dropdown collapse navbar-collapse justify-content-between" id="main-nav-dropdown">
				<ul class="navbar-nav">
					<template v-if="!isInEventPage">
						<li class="nav-item" :class="{ 'active': isMenuActive('/events') }">
							<router-link class="nav-link nav-link-text" to="/events">
								<span class="link-label">{{ $t('events') }}</span>
							</router-link>
						</li>
						<template v-if="user.role == 'super_admin' || user.role == 'client'">
							<!-- Events -->
							<li class="nav-item" :class="{ 'active': isMenuActive('/admin/events') }">
								<router-link class="nav-link nav-link-text" to="/admin/events">
									<span class="link-label">{{ $t('manageEvents') }}</span>
								</router-link>
							</li>

							<!-- Theme -->
							<li class="nav-item" :class="{ 'active': isMenuActive('/theme') }">
								<router-link class="nav-link nav-link-text" to="/theme">
									<span class="link-label">{{ $t('My Theme') }}</span>
								</router-link>
							</li>
						</template>
						<template v-if="user.role == 'super_admin'">
							<li class="nav-item" :class="{ 'active': isMenuActive('/admin/user-manuals') }">
								<router-link class="nav-link nav-link-text" to="/admin/user-manuals">
									<span class="link-label">{{ $t('User manuals') }}</span>
								</router-link>
							</li>
							<li class="nav-item" :class="{ 'active': isMenuActive('/admin/clients') }">
								<router-link class="nav-link nav-link-text" to="/admin/clients">
									<span class="link-label">{{ $t('clients') }}</span>
								</router-link>
							</li>
							<li class="nav-item" :class="{ 'active': isMenuActive('/admin/users') }">
								<router-link class="nav-link nav-link-text" to="/admin/users">
									<span class="link-label">{{ $t('Super Admin') }}</span>
								</router-link>
							</li>
							<li class="nav-item" :class="{ 'active': isMenuActive('/admin/statistics') }">
								<router-link class="nav-link nav-link-text" to="/admin/statistics">
									<span class="link-label">{{ $t('statistics') }}</span>
								</router-link>
							</li>
							<li class="nav-item dropdown">
								<a class="nav-link nav-link-text dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
									{{ $t('Settings') }}
								</a>
								<div class="dropdown-menu" aria-labelledby="navbarDropdown">
									<router-link class="dropdown-item" to="/admin/announcements">
										<span class="link-label">{{ $t('Announcements') }}</span>
									</router-link>
									<router-link class="dropdown-item" to="/admin/inactive-users">
										<span class="link-label">{{ $t('Inactive Users') }}</span>
									</router-link>
								</div>
							</li>
						</template>
					</template>

					<template v-if="isInEventPage && isLoggedIn">
						<template v-if="isInNowPage && agendaSelected">
							<li class="nav-item pointer">
								<a class="nav-link nav-link-text agenda-list" @click="returnToAgendaList()">
									<span class="link-label">{{ $t('agenda') }}</span>
								</a>
							</li>
							<li class="nav-item pointer">
								<a class="nav-link nav-link-text arrow-agenda-selected">
									<i class="material-icons">arrow_forward_ios</i>
								</a>
							</li>
							<li class="nav-item pointer">
								<a
									class="nav-link nav-link-text"
									:class="{ 'active': !isAgendaActiveSelected, 'active-agenda': isAgendaActiveSelected }"
									@click="setAgenda(agendaSelected)">
									<span class="link-label" v-tooltip="tooltipAgendaSelected">
										{{ agendaSelected.name && agendaSelected.name.length > 80 ? agendaSelected.name.substring(0, 80) + '...' : agendaSelected.name }}
									</span>
								</a>
							</li>
						</template>

						<!-- if no selected agenda -->
						<template v-if="!agendaSelected">
							<li class="nav-item">
								<router-link class="nav-link nav-link-text now-label" :to="{name: 'EventNow', params: {eventSlug: eventSlug}}">
									<span class="link-label">{{ $t('agenda') }}</span>
								</router-link>
							</li>
							<template v-if="activeAgenda">
								<li class="nav-item pointer">
									<a class="nav-link nav-link-text arrow-agenda-selected">
										<i class="material-icons">arrow_forward_ios</i>
									</a>
								</li>
								<li class="nav-item pointer">
									<a class="nav-link nav-link-text active-agenda" @click="setAgenda(activeAgenda)">
										<span class="link-label" v-tooltip="tooltipAgenda(activeAgenda)">
											{{ activeAgenda.name && activeAgenda.name.length > 90 ? activeAgenda.name.substring(0, 90) + '...' : activeAgenda.name }}
										</span>
									</a>
								</li>
							</template>
						</template>
					</template>
				</ul>

				<ul class="navbar-nav d-flex align-items-center">
					<li class="nav-item m-0" v-if="isInEventPage && isChatChannelEnabled">
						<ChatNotifications></ChatNotifications>
					</li>
					<li class="nav-item m-0" v-if="isInEventPage && isMessagesEnabled">
						<MessageNotifications></MessageNotifications>
					</li>

					<li class="nav-item m-0 language-nav-switcher" v-if="userLanguage && isLanguageSwitcherEnabled">
						<md-menu md-direction="top-start">
							<a md-menu-trigger aria-haspopup="true" aria-expanded="true" class="nav-link dropdown-toggle language-toggle d-flex align-items-center">
								<img src="../assets/images/flags/norway.png" class="max-w-25 mr-2" alt="language flag" v-if="userLanguage === 'no'">
								<img src="../assets/images/flags/united_kingdom.png" class="max-w-25 mr-2" alt="language flag" v-else>
							</a>
							<md-menu-content class="mm-dropdown-menu mm-dropdown-language-switcher">
								<md-menu-item @click="setLanguage('en')">
									<img src="../assets/images/flags/united_kingdom.png" class="max-w-25 mr-2" alt="language flag">
									<span class="language-label">English</span>
								</md-menu-item>
								<md-menu-item @click="setLanguage('no')">
									<img src="../assets/images/flags/norway.png" class="max-w-25 mr-2" alt="language flag">
									<span class="language-label">Norsk</span>
								</md-menu-item>
							</md-menu-content>
						</md-menu>
					</li>

					<!-- Dropdown Menu -->
					<li class="nav-item dropdown show profile-menu">
						<span class="label-name nav-link">
							{{ user.first_name }} {{ user.last_name }}
						</span>
					</li>

					<!-- Mega Menu -->
					<li class="nav-item mega-menu-toggle ml-1" v-if="isLoggedIn">
						<i class="material-icons" @click="toggleMegaMenu()">{{ this.isShowMegaMenu ? 'close' : 'menu' }}</i>
					</li>
				</ul>
			</div>
		</div>
		<div class="modals">
			<!-- Change role -->
			<ModalRoleChange
				:show="isShowModalChangeRole"
				@close="closeChangeRole()">
			</ModalRoleChange>

			<!-- Logout confirmation -->
			<ModalLogout
				:show="isShowModalLogout"
				@close="closeModalLogoutConfirmation()">
			</ModalLogout>

			<!-- User manuals -->
			<ModalUserManual
				:show="isShowUserManual"
				@close="closeUserManual()"
				v-if="isShowUserManual">
			</ModalUserManual>

			<!-- Modal QR Participant -->
			<modal-qr-participant
				:show="isShowQrEvent"
				:event="event"
				:participant="participant"
				@close="closeQrEvent()"
				v-if="event && participant && isShowQrEvent"
			/>
		</div>
	</nav>
</template>

<script>
import participantApi from '@/api/participants';
import userApi from '@/api/user';

import { checkRoleOwned, isJsonString } from '@/lib/helper';

import { mapGetters, mapActions } from 'vuex';
import MessageNotifications from '@/components/MessageNotifications.vue';
import ModalHelp from '@/components/ModalHelp.vue';
import ModalRoleChange from '@/components/ModalRoleChange.vue';
import ModalLogout from '@/components/ModalLogout.vue';
import ModalUserManual from '@/components/ModalUserManual.vue';
import ChatNotifications from '@/components/ChatNotifications.vue';
import MainMegaMenu from '@/components/menu/MainMegaMenu.vue';
import ModalQrParticipant from '@/components/participants/ModalQrParticipant.vue';

export default {
	name: 'MainNav',
	components: {
		MessageNotifications,
		ModalHelp,
		ModalRoleChange,
		ModalLogout,
		ChatNotifications,
		ModalUserManual,
		MainMegaMenu,
		ModalQrParticipant,
	},
	data() {
		return {
			shrink: false,
			isShowModalHelp: false,
			isShowModalChangeRole: false,
			isShowModalLogout: false,
			participant: null,
			isShowUserManual: false,
			isShowMegaMenu: false,
			isShowQrEvent: false,
		};
	},
	mounted() {
		this.fetchParticipantMe();
	},
	methods: {
		...mapActions({
			logout: 'logout',
			setAgenda: 'now/setAgenda',
		}),
		handleScroll() {
			const scrollPosition = window.scrollY;
			const treshold = 0;
			if (scrollPosition > treshold) {
				this.shrink = true;
			} else {
				this.shrink = false;
			}
		},
		showModalHelp() {
			this.isShowModalHelp = true;
		},
		closeModalHelp() {
			this.isShowModalHelp = false;
		},
		gotToMainMenu() {
			if (!this.isLoggedIn) return;

			if (this.user.role === 'super_admin' || this.user.role === 'client') {
				this.$router.push({ name: 'AdminEvents' });
			} else if (this.user.role === 'delegate') {
				this.$router.push({ name: 'Events' });
			} else {
				this.$router.push({ name: 'Events' });
			}
		},
		showModalLogoutConfirmation() {
			this.isShowModalLogout = true;
		},
		closeModalLogoutConfirmation() {
			this.isShowModalLogout = false;
		},
		returnToAgendaList() {
			this.setAgenda(null);
			if (this.locationName !== 'EventNow') {
				this.$router.push({ name: 'EventNow', params: { eventSlug: this.eventSlug } }).then(() => {}).catch(() => {});
			}
		},
		fetchParticipantMe() {
			if (!this.isLoggedIn) return;

			if (!this.eventSlug) {
				this.participant = null;
				return;
			}
			const params = {
				event_slug: this.eventSlug,
			};
			participantApi.getMe(params, (response) => {
				const participant = response;
				this.participant = participant;
			}, () => {});
		},
		tooltipAgenda(agenda) {
			const text = agenda && agenda.name ? `${this.$t('activeAgenda')} - ${agenda.name}` : '';
			return text;
		},
		showUserManual() {
			this.isShowUserManual = true;
		},
		closeUserManual() {
			this.isShowUserManual = false;
		},
		showChangeRole() {
			this.isShowModalChangeRole = true;
		},
		closeChangeRole() {
			this.isShowModalChangeRole = false;
		},
		setLanguage(lang) {
			if (!this.user || this.userLanguage === lang) return;

			const params = {
				language: lang,
				id: this.user.id,
			};
			const callback = (response) => {
				const newUser = response.data;
				this.$store.dispatch('setUser', newUser);
			};
			const errorCallback = () => {};
			userApi.updateUser(params, callback, errorCallback);
		},
		toggleMegaMenu() {
			this.isShowMegaMenu = !this.isShowMegaMenu;
		},
		closeMegaMenu() {
			this.isShowMegaMenu = false;
		},
		showQrEvent() {
			this.isShowQrEvent = true;
		},
		closeQrEvent() {
			this.isShowQrEvent = false;
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			customNavLogo: 'customNavLogo',
			isMenuActive: 'isMenuActive',
			isLoggedIn: 'isLoggedIn',
			currentRole: 'now/currentRole',
			event: 'now/event',
			agenda: 'now/agenda',
			activeAgenda: 'now/activeAgenda',
		}),
		participantRoles() {
			let roles = [];
			if (this.participant && isJsonString(this.participant.roles)) roles = JSON.parse(this.participant.roles);
			return roles;
		},
		isSuperAdminClient() {
			let isRoled = false;
			if (this.user) {
				if (this.user.role === 'super_admin' || this.user.role === 'client') isRoled = true;
			}
			return isRoled;
		},
		isSuperAdmin() {
			let isRoled = false;
			if (this.user && this.user.role === 'super_admin') isRoled = true;
			return isRoled;
		},
		isAdminEvent() {
			return this.participant ? checkRoleOwned(this.participant, 'admin') : false;
		},
		isModeratorEvent() {
			return this.participant ? checkRoleOwned(this.participant, 'moderator') : false;
		},
		isSecretaryEvent() {
			return this.participant ? checkRoleOwned(this.participant, 'secretary') : false;
		},
		isEditorialEvent() {
			return this.participant ? checkRoleOwned(this.participant, 'editorial') : false;
		},
		isRegistrationEvent() {
			return this.participant ? checkRoleOwned(this.participant, 'registration') : false;
		},
		isSetAgenda() {
			return this.participant ? checkRoleOwned(this.participant, 'set_agenda') : false;
		},
		isParticipantsRole() {
			return this.participant ? checkRoleOwned(this.participant, 'participants') : false;
		},
		location() {
			const location = this.$store.getters.location;
			return location;
		},
		locationName() {
			const locationName = this.location.to.name;
			return locationName;
		},
		isInEventPage() {
			const eventSlug = this.$route.params.eventSlug;
			const isIn = eventSlug !== undefined;
			return isIn;
		},
		isInNowPage() {
			const isIn = this.locationName === 'EventNow';
			return isIn;
		},
		eventSlug() {
			return this.$route.params.eventSlug;
		},
		agendaSelected() {
			return this.agenda;
		},
		isAgendaActiveSelected() {
			const isActive = this.agenda ? this.agenda.status === 'active' : false;
			return isActive;
		},
		tooltipAgendaSelected() {
			const text = this.isAgendaActiveSelected ? `${this.$t('activeAgenda')} - ${this.agendaSelected.name}` : '';
			return text;
		},
		appVersion() {
			return this.$store.getters.appVersion;
		},
		eventSettings() {
			return this.event && this.event.settings ? JSON.parse(this.event.settings) : false;
		},
		isChatChannelEnabled() {
			let isEnabled = false;
			if (this.eventSettings && this.eventSettings.is_chat_channel_enabled !== undefined) isEnabled = this.eventSettings.is_chat_channel_enabled;
			return isEnabled;
		},
		isMessagesEnabled() {
			let isEnabled = false;
			if (this.eventSettings && this.eventSettings.is_messages_enabled !== undefined) isEnabled = this.eventSettings.is_messages_enabled;
			return isEnabled;
		},
		isLanguageSwitcherEnabled() {
			let isEnabled = false;
			if (this.eventSettings && this.eventSettings.is_language_switcher_enabled !== undefined) isEnabled = this.eventSettings.is_language_switcher_enabled;
			return isEnabled;
		},
		userLanguage() {
			return this.user ? this.user.language : '';
		},
	},
	watch: {
		$route() {
			// eslint-disable-next-line
			$('#main-nav-dropdown').collapse('hide');
		},
		eventSlug() {
			if (this.eventSlug) {
				this.fetchParticipantMe();
			}
		},
	},
	created() {
		window.addEventListener('scroll', this.handleScroll);
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
	},
};
</script>
<style lang="scss" scoped>
.agenda-label-selected-wrap {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 500px;
}

.btn-logout {
	color: #F20F0D;
}

.image-label-name {
	top: 0 !important;
}

.image-profile {
	width: 36px;
	height: 36px;
	border-radius: 20px;
	border: 2px solid #FFF;
}

.nav-user-info {
	padding: 10px 16px;
	border-bottom: 1px solid #d7d7d7;
	background-color: #737373;
    color: #FFF;
	.icon-badge {
		font-size: 40px;
	}
	.user-profile-name {
		position: relative;
	}
}
</style>
